// useSuzgecDurulmasi.js — SÜZGEÇ DURULUNCA SORGUYA GEÇER, SAYFA BAŞA DÖNER — TEK KAYNAK (6 Eki 2026 · 24 ay şartı, 3. adım)
//
// 🔑 Süzgeçleri SORGUYA giden ekranlarda (ARCHIVED FLTS, EDIT REPORTS, STATISTICS) yazarken her tuşta sunucuya
//    gidilmesin: süzgeç `ms` (250) boyunca değişmezse sorguya geçer ve sayfa 1'e döner — ikisi AYNI anda (tek çizim,
//    tek sorgu; eski sayfanın yeni süzgeçle okunması yok). Tarih kutusunda yıl elle yazılırken ara değerler
//    (0002, 0020, 0202 …) de sunucuya gitmez.
// 🔑 Açılışta zamanlayıcı KURULMAZ — süzgeç zaten sorgudadır (boşuna çizim ve test gürültüsü olmasın).
// @param suzgec    ekrandaki süzgeç (her değişiklikte yeni nesne)
// @param setSayfa  sayfa durumunun kurucusu (sabit kimlik — React state setter); yoksa sayfa yoktur
// @returns sorguya giden (durulmuş) süzgeç
import { useEffect, useRef, useState } from 'react';

export default function useSuzgecDurulmasi(suzgec, setSayfa = null, ms = 250) {
  const [durulmus, setDurulmus] = useState(suzgec);
  const ilk = useRef(true);
  useEffect(() => {
    if (ilk.current) { ilk.current = false; return undefined; }
    const t = setTimeout(() => { setDurulmus(suzgec); if (setSayfa) setSayfa(1); }, ms);
    return () => clearTimeout(t);
  }, [suzgec, setSayfa, ms]);
  return durulmus;
}
